class LegacyDataCenterStorage {
    private storageKey = 'legacy';

    /**
     * Stores the provided datacenters in local storage.
     */
    setItems(datacenters: String[]): void{
        if (datacenters.length > 0) {
            localStorage.setItem(this.storageKey, datacenters.join(','));
        }
    };

    /**
     * Retrieves datacenters from local storage.
     */
    getItems(allowedDatacenters: string[]): string[]{
        const storedDatacentersString = localStorage.getItem(this.storageKey);
        const storedDatacenters = storedDatacentersString ? storedDatacentersString.split(',') : [];

        return storedDatacenters.reduce((output: string[], datacenter) => {
            // Check if the datacenter is allowed and not already in the output
            if (
                allowedDatacenters.includes(datacenter)
                && !output.includes(datacenter)
            ) {
                output.push(datacenter);
            }
            return output;
        }, []);
    };

    /**
     * Clears the stored datacenters from local storage.
     */
    clearAll() {
        localStorage.removeItem(this.storageKey);
    }
}

export { LegacyDataCenterStorage };
